import { useState } from "react";
import { Toaster } from "react-hot-toast";
import Button from "../../../components/Button";
import IconButton from "../../../components/IconButton";
import Input from "../../../components/Input";
import InputSelect from "../../../components/Input-select";
import { toastError } from "../../../components/Toast";
import useAuthData from "../../../hook/useAppData";
import { IconAdd } from "../../../icons";
import { currentDate } from "../../../libs/dateUtils";
import { IModalNewInvoice } from "../models";
import { uploadInvoice } from "../service";

export const ContentModalNewInvoice = ({ closeModal }: IModalNewInvoice) => {
  const { currentBrowser, token } = useAuthData();
  const [year, month] = new Date(currentDate()).toLocaleDateString("pt-br", { month: "numeric", year: "numeric" }).split("/").reverse();
  const [dateOfInvoice, setDateOfInvoice] = useState(`${year}-${month}`);
  const [monthOfSelect, setMonthOfSelect] = useState<number>(+month);
  const [yearOfSelect, setYearOfSelect] = useState<number>(+year);
  const [file, setFile] = useState<any>();

  const getDateFromAndDateTo = (): { year: string; month: string } => {
    const [year, month] = dateOfInvoice?.split("-");

    return { year, month };
  };

  const handleFile = (target: any) => {
    if (!target?.files[0]?.type?.includes("application/pdf")) return toastError("Esse arquivo não é um PDF!");
    setFile(target.files[0]);
  };

  const saveClick = async () => {
    const { year, month } = currentBrowser !== "Firefox" ? getDateFromAndDateTo() : { year: yearOfSelect, month: monthOfSelect };

    const res = await uploadInvoice({ token, file, year: String(year), month: String(month).padStart(2, "0") });
    if (res?.ok) return closeModal(true);
    if (res?.status === 404) return toastError("Não foi possível encontrar o fechamento do mês selecionado");
    if (res?.status === 413) return toastError("O arquivo é muito grande, tente um arquivo menor");
    return toastError("Erro ao salvar o arquivo");
  };

  return (
    <>
      <div className="h-220px flex flex-col justify-between ">
        <div className="flex items-end h-1/3">
          <p className="w-full font-semibold text-1.6rem mb-7">Selecione o mês referente a essa nota fiscal:</p>
          {currentBrowser === "Chrome" ? (
            <>
              <Input
                name={"dateOfInvoice"}
                label={"Mês da Nota Fiscal"}
                type="month"
                placeholder={dateOfInvoice}
                value={dateOfInvoice}
                onChange={(e) => setDateOfInvoice(e.target.value)}
                className="input-date-invoice"
              />
            </>
          ) : (
            <div className="w-4/5 flex">
              <InputSelect
                name={"dateOfInvoice"}
                label={"Mês"}
                list={generateListOfMonths()}
                onChange={(e) => setMonthOfSelect(+e.target.value)}
                value={monthOfSelect}
              />
              <InputSelect
                name={"dateOfInvoice"}
                label={"Ano"}
                list={generateListOfYears()}
                onChange={(e) => setYearOfSelect(+e.target.value)}
                value={undefined}
              />
            </div>
          )}
        </div>
        <div className="flex items-end h-1/3 gap-20">
          <p className="w-1/2 font-semibold text-1.6rem mb-7">Selecione a nota fiscal que deseja salvar:</p>
          <label className="box-file-invoice-modal input-type-file cursor-pointer mb-5 w-5/12">
            <input type="file" onChange={(e) => handleFile(e.target)} accept="application/pdf" />
            <IconButton icon={IconAdd} className="justify-center bg-secondary w-full rounded-lg shadow-xl" />
          </label>
        </div>
        <div className="box-button-invoice-modal flex justify-end gap-8">
          <Button onClick={() => closeModal(false)} className="bg-white border-2 border-primary text-primary font-bold">
            Cancelar
          </Button>
          <Button onClick={() => saveClick()} className="bg-primary">
            Salvar
          </Button>
        </div>
      </div>
    </>
  );
};

// gerate one list of months in a object with key label and value name of month and key id and value number of month
const generateListOfMonths = () => {
  const months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  return months.map((month, index) => ({ label: month, value: index + 1 }));
};

// gerate one list of years with last value current year
const generateListOfYears = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear; i > currentYear - 10; i--) {
    years.push({ label: i, id: i });
  }
  return years;
};
